import { useState, useEffect } from 'react';
import { getQueueStats } from '../api/quickDuel';
import { subscribeToQuickDuelStats } from '../api/websocket';

/**
 * React хук для получения статистики очереди быстрых дуэлей
 * @param {number} refreshInterval - Интервал обновления в мс (по умолчанию 10000)
 * @returns {Object} Статистика, состояние загрузки и ошибка
 */
export function useQuickDuelStats(refreshInterval = 10000) {
    const [stats, setStats] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchStats = async () => {
        try {
            const data = await getQueueStats();
            setStats(data);
            setError(null);
        } catch (err) {
            setError(err.message || 'Failed to fetch stats');
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchStats();

        // Подписка на WebSocket обновления
        const subscription = subscribeToQuickDuelStats((event) => {
            setStats({
                activeQueues: event.activeQueues,
                soloQueues: event.soloQueues,
                team2v2Queues: event.team2v2Queues,
                averageWaitSeconds: event.averageWaitSeconds,
                yourPosition: null,
            });
        });

        // Polling как fallback
        const interval = setInterval(fetchStats, refreshInterval);

        return () => {
            if (subscription) {
                subscription.unsubscribe();
            }
            clearInterval(interval);
        };
    }, [refreshInterval]);

    return { stats, isLoading, error, refresh: fetchStats };
}

export default useQuickDuelStats;
